"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var G = tslib_1.__importStar(require("@antv/g"));
var g2_1 = require("@antv/g2");
var _ = tslib_1.__importStar(require("@antv/util"));
// 记录之前的状态
var shapeCache;
function clipInFromCenterVertical(shape, animateCfg) {
    var bbox = shape.getBBox();
    var centerY = bbox.minY + bbox.height / 2;
    var cliper = new G.Rect({
        attrs: {
            x: bbox.minX,
            y: centerY,
            width: bbox.width,
            height: 0,
        },
    });
    shape.attr('clip', cliper);
    cliper.animate({
        height: bbox.height,
        y: bbox.minY,
    }, animateCfg.duration, animateCfg.easing, function () {
        shape.attr('clip', null);
    }, animateCfg.delay);
}
clipInFromCenterVertical.animationName = 'clipInFromCenterVertical';
function setShapeCache(shapes) {
    shapeCache = shapes;
}
exports.setShapeCache = setShapeCache;
function updateFromCenterVertical(shape, animateCfg) {
    var fromPath = getShapeFromCache(shape).attr('path');
    var toPath = _.clone(shape.attr('path'));
    shape.attr('path', fromPath);
    shape.animate({
        path: toPath,
    }, animateCfg.duration, animateCfg.easing, animateCfg.callback, 100);
}
function getShapeFromCache(shape) {
    var id = shape.id;
    var target;
    _.each(shapeCache, function (s) {
        if (s.id === id) {
            target = s;
        }
    });
    return target;
}
updateFromCenterVertical.animationName = 'updateFromCenterVertical';
g2_1.Animate.registerAnimation('appear', 'clipInFromCenterVertical', clipInFromCenterVertical);
g2_1.Animate.registerAnimation('update', 'updateFromCenterVertical', updateFromCenterVertical);
//# sourceMappingURL=animation.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/range-column/animation.js
// module id = 958
// module chunks = 37